export const SESSION_REDIRECT_KEY = 'parabo.signin.redirect';
